import { CSRF_TOKEN_ID } from "../constants";
export var getCsrfToken = function() {
    var csrfTokenMeta = document.querySelector("meta[name='".concat(CSRF_TOKEN_ID, "']"));
    var ref;
    return (ref = csrfTokenMeta === null || csrfTokenMeta === void 0 ? void 0 : csrfTokenMeta.getAttribute("content")) !== null && ref !== void 0 ? ref : "";
};
export default getCsrfToken;

//# sourceMappingURL=csrf.js.map